module.exports = __webpack_public_path__ + "media/images/dmc/dmc_service-03-d3cfe614362ee9f09b3720fa6a9df6fd.jpg";